export default __webpack_public_path__ + "static/2003-f70607eb6347fa390fc6bf8e3e9bfe01.gif";